import apiClient from './apiClient';

export const getPlans = async () => {
  const response = await apiClient.get('/subscriptions/plans');
  return response.data;
};

export const createPlan = async (planData) => {
  const response = await apiClient.post('/subscriptions/plans', planData);
  return response.data;
};

export const updatePlan = async (planId, planData) => {
  const response = await apiClient.put(`/subscriptions/plans/${planId}`, planData);
  return response.data;
};

export const getOrganizations = async () => {
  const response = await apiClient.get('/subscriptions/organizations');
  return response.data;
};

export const assignPlan = async (orgId, assignmentData) => {
  const response = await apiClient.put(`/subscriptions/organizations/${orgId}/plan`, assignmentData);
  return response.data;
};

export const updateOverrides = async (orgId, overrideData) => {
  const response = await apiClient.put(`/subscriptions/organizations/${orgId}/overrides`, overrideData);
  return response.data;
};

export const getAuditLogs = async (params) => {
  const response = await apiClient.get('/subscriptions/audit-logs', { params });
  return response.data;
};
